import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is carried by an httpOnly `access_token` cookie set by the backend
// on /auth/login and /auth/register. `withCredentials: true` sends it on
// every request. We do NOT keep the token in localStorage/sessionStorage
// so an XSS payload can't exfiltrate it.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}
